import { useUI } from "providers/UIProvider"

import { Box, Flex } from "@chakra-ui/react"
import Checkbox from "components/UI/atoms/Checkbox"
import Heading from "components/UI/atoms/Heading"
import SearchInput from "components/UI/molecules/SearchInput"
import { ILoundriesToolbarProps } from "./LoundriesToolbarTypes"
import { useLaundriesContext } from "providers/LaundriesProvider/LaundriesProvider"

const LoundriesToolbar: React.FC<ILoundriesToolbarProps> = () => {
    const { T } = useUI()

    const { searchValue, isOpenedChecked, isClosedChecked, handleStatusCheckboxClick, handleSearchChange }  = useLaundriesContext()

    return(
        <Box
      padding="25px"
      backgroundColor="white"
      borderTopRadius="base"
      boxShadow="primary"
    >
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center">
          <Heading title={T("laundries.table.title")} variant="bold" />
        </Flex>
        <Flex alignItems="center" gap="20px">
          <Checkbox
            isChecked={isOpenedChecked}
            onChange={()=>handleStatusCheckboxClick("isOpenedChecked")}
            label={T("laundries.table.toolbar.checkbox.open")}
           
          />
          <Checkbox
             isChecked={isClosedChecked}
             onChange={()=>handleStatusCheckboxClick("isClosedChecked")}
            label={T("laundries.table.toolbar.checkbox.close")}
          />
          <SearchInput 
            value={searchValue || ""}
            onChange={handleSearchChange}
            onSearchClick={()=> {}}
          />
        </Flex>
      </Flex>
    </Box>
    )
}

export default LoundriesToolbar